import React, { useEffect, useState, useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import TableContainerServer from "@components/Common/TableContainerServer";
import { Col, Container, Row } from "reactstrap";
import { Email, Img } from "@/shared/components/table/contactCells";
import Breadcrumbs from "@components/Common/Breadcrumb";
import DeleteModal from "@components/Common/DeleteModal";
import api from "@/shared/services/api";
import { ColumnDef, PaginationState } from "@tanstack/react-table";
import { tryCatch } from "@/helpers/async_helper";
import { notificationUtils } from "@/utils/notificationToast";
import { formatDate, formatDateTime } from "@/helpers/date_helper";

const RateHistory = () => {
  const title = "Histórico de tasa diaria BCV";
  document.title = `${title} | ${import.meta.env.VITE_APP_TITLE}`;

  const [deleteModal, setDeleteModal] = useState(false);
  const [list, setList] = useState([]);
  const [totalCount, setTotalCount] = useState(0); // Total number of records
  const [pagination, setPagination] = React.useState<PaginationState>({
    pageIndex: 0,
    pageSize: 50,
  });
  const [globalFilter, setGlobalFilter] = useState("");
  const pageCount = useMemo(
    () => Math.ceil(totalCount / pagination.pageSize),
    [totalCount, pagination.pageSize]
  );
  const [loading, setLoading] = useState(false);

  const columns = useMemo<ColumnDef<any>[]>(
    () => [
      //   {
      //     header: "#",
      //     cell: () => {
      //       return <input type="checkbox" className="form-check-input" />;
      //     },
      //   },
      //   {
      //     header: "Foto",
      //     accessorKey: "img",
      //     cell: (cell) => {
      //       return <Img value={cell.getValue()} />;
      //     },
      //   },
      //   {
      //     header: "Nombre",
      //     accessorKey: "name",
      //     cell: (cell: any) => (
      //       <h5 className="font-size-14 mb-1">
      //         <Link to="#" className="text-dark">
      //           {cell.getValue()}
      //         </Link>
      //       </h5>
      //     ),
      //   },
      {
        header: "Fecha de creación",
        accessorKey: "createdAt",
        cell: (cell: any) => formatDateTime(cell.getValue()),
      },
      {
        header: "Fecha válida",
        accessorKey: "validDate",
        cell: (cell: any) => formatDate(cell.getValue()),
      },
      {
        header: "Tasa",
        accessorKey: "usd",
        cell: (cell) => cell.getValue(),
      },
    ],
    []
  );

  const getList = async () => {
    setLoading(true);
    try {
      const response = await api.get(`/rate/history`, {
        params: {
          page: pagination.pageIndex + 1, // APIs often use 1-based indexing for pages
          limit: pagination.pageSize,
          globalFilter: globalFilter,
          // Add sorting and filtering parameters here if your API supports them
          // For example:
          // sortBy: sorting.length > 0 ? sorting[0].id : undefined,
          // sortDirection: sorting.length > 0 ? (sorting[0].desc ? 'desc' : 'asc') : undefined,
          // columnFilters: columnFilters,
        },
      });
      // Assuming your API returns data in a format like:
      // { data: [...], totalCount: 100 }
      setList(response.data.data); // Actualiza el estado con los datos formateados
      setTotalCount(response.data.totalCount);
    } catch (error: any) {
      console.error("Error fetching data:", error);
      notificationUtils("danger", "Error fetching data.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getList(); // Llama a la función para obtener los clientes
  }, [pagination, globalFilter]);

  //   const handleChangeStatus = async (userData: any) => {
  //     const { data: response, error } = await tryCatch(
  //       api.patch(`/admin/users/${userData.id}`, { status: userData.status.id === "active" ? "inactive" : "active" })
  //     );
  //     if (error || response === null) {
  //       console.error("Error changing status:", error);
  //     } else {
  //       notificationUtils("success", "Cambio de estatus realizado con éxito");
  //       getUsers();
  //     }
  //   };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Usuarios" breadcrumbItem={title} />
          <Row>
            <Col lg="12">
              <Row className="align-data-center">
                <Col md={6}>
                  <div className="mb-3">
                    <h5 className="card-title">
                      Total{" "}
                      <span className="text-muted fw-normal ms-2">
                        ({totalCount})
                      </span>{" "}
                    </h5>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col xl="12">
                  <TableContainerServer
                    columns={columns}
                    data={list}
                    isGlobalFilter={true}
                    isAddUserList={true}
                    pagination={pagination}
                    setPagination={setPagination}
                    pageCount={pageCount}
                    totalCount={totalCount}
                    globalFilter={globalFilter} // Pass globalFilter state
                    setGlobalFilter={setGlobalFilter} // Pass setGlobalFilter function
                    setSorting={[] as any} // Pass setSorting
                    setColumnFilters={[] as any} // Pass setColumnFilters
                    className="table align-middle datatable dt-responsive table-check nowrap"
                  />
                </Col>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default RateHistory;
